import { InjectionToken } from '@angular/core';

/**
 * Injection token for redirect configuration
 * Provides API endpoint URL for redirect operations
 */
export const REDIRECT_CONFIG = new InjectionToken<RedirectConfigInterface>('REDIRECT_CONFIG');

/**
 * Configuration interface for redirect functionality
 */
export interface RedirectConfigInterface {
  api: {
    url: string; // Base URL for redirect API endpoints
  };
  targetHost: string;
}
